import { FLOWCHART_SHAPES } from "./flowchart";

import type { ShapeCategory, ShapeDefinition } from "./types";

export const SHAPES: readonly ShapeDefinition[] = [...FLOWCHART_SHAPES];

export const SHAPES_BY_CATEGORY: Record<ShapeCategory, ShapeDefinition[]> = {
  flowchart: [...FLOWCHART_SHAPES],
};

export type { ShapeDefinition, ShapeCategory } from "./types";
